import { buildScopedI18n } from '../../utils/buildScopedI18n';
import configLayoutEsCL from './locales/es-CL.json';
import configLayoutEnUS from './locales/en-US.json';
import configLayoutPtBR from './locales/pt-BR.json';

export const configLayoutI18n = buildScopedI18n({
  esCL: configLayoutEsCL,
  enUS: configLayoutEnUS,
  ptBR: configLayoutPtBR,
});
